import React, { useState, useEffect, Suspense } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";

import DynamicDayPage from "./pages/DynamicDayPage"; // Renamed from MainPage
import GetItinerary from "./pages/GetItinerary";
import BudgetTiers from "./pages/BudgetTiers";
import Header from "./_components/_global/Header";
import Footer from "./_components/_global/Footer";

import MainPage from "./pages/MainPage";

import { UserPreferencesProvider } from "./_components/common/UserPreferencesContext";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import ActivityDescriptionPage from "./pages/ActivityDescriptionPage";
import ProtectedRoute from "./ProtectedRoute";
import { ActivitiesProvider } from "./context/ActivitiesContext";
import CartPage from "./pages/CartPage";

import ChatPage from "./pages/ChatPage";
import CheckoutPage from "./pages/CheckoutPage";
import WelcomeScreen from "./pages/WelcomeScreen";
import CitySelection from "./pages/CitySelection";
import FeatureHome from "./pages/FeatureHome";
import DemoPage from "./pages/DemoPage";
import CityReview from "./pages/CityReview";
import Profile from "./pages/Profile";
import Explore from "./pages/ExplorePage";
import CommunityHub from "./pages/CommunityHub";
import BookingCart from "./pages/BookingCart";
import Welcomepage from "./pages/WelcomepageDesktop";
import CitySelectionDesktop from "./pages/CitySelectionDesktop";
import FeatureHomeDesktop from "./pages/FeatureHomeDesktop";
import CommunityDesktop from "./pages/CommunityDesktop";
import ProfileDesktop from "./pages/ProfileDesktop";
import MessageDesktop from "./pages/MessageDesktop";
import TripPlannerDesktop from "./pages/TripPlannerDesktop";
import Notifications from "./pages/Notification";
import TripPlanner from "./pages/TripPlanner";
import NotFoundPage from "./pages/NotFoundPage";
import WatchDemo from "./pages/WatchDemo";
import PricingPage from "./pages/PricingPage";
import BlogPage from "./pages/BlogPage";
import ContactPage from "./pages/ContactPage";
import Architecture from "./pages/ArchitectureDiagram";

function useMediaQuery(query) {
  const [match, setMatch] = useState(false);
  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = () => setMatch(mql.matches);
    onChange();
    mql.addEventListener?.("change", onChange) ?? mql.addListener(onChange);
    return () =>
      mql.removeEventListener?.("change", onChange) ??
      mql.removeListener(onChange);
  }, [query]);
  return match;
}

function App() {
  return (
    <UserPreferencesProvider>
      <Router>
        <AppContent />
      </Router>
    </UserPreferencesProvider>
  );
}

function ResponsiveLanding() {
  const isDesktop = useMediaQuery("(min-width: 992px)");
  return (
    <Suspense fallback={null}>
      {isDesktop ? <Welcomepage /> : <WelcomeScreen />}
    </Suspense>
  );
}

function CitySelectionResponsive() {
  const isDesktop = useMediaQuery("(min-width: 992px)");
  return (
    <Suspense fallback={null}>
      {isDesktop ? <CitySelectionDesktop /> : <CitySelection />}
    </Suspense>
  );
}

function FeatureHomeResponsive() {
  const isDesktop = useMediaQuery("(min-width: 992px)");
  return (
    <Suspense fallback={null}>
      {isDesktop ? <FeatureHomeDesktop /> : <Explore />}
    </Suspense>
  );
}

function CommunityHubResponsive() {
  const isDesktop = useMediaQuery("(min-width: 992px)");
  return (
    <Suspense fallback={null}>
      {isDesktop ? <CommunityDesktop /> : <CommunityHub />}
    </Suspense>
  );
}

function ProfileResponsive() {
  const isDesktop = useMediaQuery("(min-width: 992px)");
  return isDesktop ? <ProfileDesktop /> : <Profile />;
}

function TripPlannerResponsive() {
  const isDesktop = useMediaQuery("(min-width: 992px)");
  return isDesktop ? <TripPlannerDesktop /> : <TripPlanner />;
}

function AppContent() {
  const location = useLocation();
  return (
    <div className="App">
      {/* Global Header */}
      {/*{location.pathname !== "/login" && */}
      {false && <Header />}
      {/*}*/}
      <Routes>
        <Route path="/" element={<ResponsiveLanding />} />
        <Route path="/city-selection" element={<CitySelectionResponsive />} />
        <Route path="/features" element={<FeatureHomeResponsive />} />
        <Route path="/community" element={<CommunityHubResponsive />} />
        <Route path="/profile" element={<ProfileResponsive />} />
        <Route path="/trip-planner" element={<TripPlannerResponsive />} />
        <Route path="/architecture" element={<Architecture />} />


        <Route path="/contact" element={<ContactPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/notifications" element={<Notifications />} />
        <Route path="feature-home" element={<FeatureHome />} />
        <Route path="/booking-cart" element={<BookingCart />} />
        <Route path="/explore" element={<Explore />} />
        <Route path="/main" element={<MainPage />} />
        <Route path="/city-reviews" element={<CityReview />} />
        <Route path="/Welcome" element={<WelcomeScreen />} />
        <Route path="/message" element={<MessageDesktop />} />
        <Route path="/demo" element={<DemoPage />} />

        <Route path="/watch-demo" element={<WatchDemo />} />
        {/* Routes for static pages */}

        <Route
          path="/get-itinerary"
          element={
            <ProtectedRoute>
              <GetItinerary />
            </ProtectedRoute>
          }
        />
        {/* Routes for budget with switch activities */}
        <Route
          path="/budget-tiers"
          element={
            <ActivitiesProvider>
              <BudgetTiers />
            </ActivitiesProvider>
          }
        />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        {/* Dynamic route for all day itineraries */}
        <Route
          path="/day/:dayNumber"
          element={
            <ActivitiesProvider>
              <DynamicDayPage />
            </ActivitiesProvider>
          }
        />
        <Route
          path="/activity-description/:id"
          element={<ActivityDescriptionPage />}
        />

        <Route path="/cart" element={<CartPage />} />
        {/* Chat demo route */}
        <Route path="/chat" element={<ChatPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        {/* Catch-all for undefined routes */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>

      {/* Footer - 根据路径条件显示 */}
      {!location.pathname.includes("/login") &&
        !location.pathname.includes("/register") &&
        !location.pathname.includes("/trip-planner") && <Footer />}
    </div>
  );
}

export default App;
